import ListItem from "../listItem";
import { translate } from "@helpers/translationObjectFormatter";
import {
    IBestOverallPageProps,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import { GQLOffers } from "@gql/types/gql";
import { stripHtmlTags, titleDecoder } from "@lib/sharedUtils";
import { Session } from "src/api/session";

export default function OfferList() {
    const { data: props } = useQuery<IBestOverallPageProps>([
        "bestOverallPageProps",
    ]);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    const session = useQuery<Session>({ queryKey: ["session"] });

    const { category, offers: domainOffers } = props ?? {};
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    const offers = domainOffers?.flatMap((item) => item.offers)?.slice(0, 5);

    const getTitle = () => {
        const titleFromTextBlock = category?.textBlocks?.find(
            (block) => block?.position === "several-best-overall-title",
        )?.text;

        if (titleFromTextBlock) {
            const titleAfterStripping =
                stripHtmlTags(titleFromTextBlock).trim();

            return titleDecoder(titleAfterStripping, {
                category: category?.label ?? category?.name ?? "",
                region: session?.data?.visitDetails?.region ?? "",
            });
        }

        const fallBackTitle = `${translate(
            translations,
            "several_categoryPage_topWord",
        )} ${
            (category?.label as string) ?? (category?.name as string)
        } ${translate(
            translations,
            "several_categoryPage_companiesInWord",
        )} ${new Date().getFullYear()}`;

        return fallBackTitle;
    };

    return (
        <>
            <h1 className="lg:mb-10 mb-7  lg:text-3xl font-bold lg:leading-[45px] text-xl leading-8">
                {getTitle()}
            </h1>
            <span className="mt-24 ">
                {offers?.map((offer, index) => (
                    <ListItem
                        key={index}
                        vendor={offer as GQLOffers}
                        categoryId={category?.id as number}
                    />
                ))}
            </span>
        </>
    );
}
